import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import api from "../api";
import urls from "../urls";
import type { ProjectMinimal } from "../utils/backend-types";

export function useProjectBySiteId({
  options,
  isFilterActive,
  siteId
}: {
  options?: Partial<UseQueryOptions<ProjectMinimal>>;
  isFilterActive?: boolean;
  siteId?: number;
}) {
  return useQuery({
    queryKey: ["projects", isFilterActive, siteId],
    queryFn: () => fetchProjectsBySiteId(isFilterActive, siteId),
    staleTime: 60 * 1000, // 1 minute
    ...options
  });
}

async function fetchProjectsBySiteId(
  isFilterActive?: boolean,
  siteId?: number
) {
  const response = await api.get<Array<ProjectMinimal>>(
    urls.api.projectsBySiteId(isFilterActive, siteId) // a site is always only in 1 project
  );
  return response.data[0];
}
